import { AttractionDetailsResponse } from '@grpc-clients/external/mercury/v1/attraction/attraction.pb';
import { AttractionProductOption } from '@grpc-clients/external/mercury/v1/attraction/common/attraction-product-option.pb';
import { ProductAvailabilityRange } from '@grpc-clients/external/mercury/v1/shared/product-availability-range.pb';
import { UppercaseGuestType } from '@shared/shared/interfaces/uppercase-guest-type';
import {
  ActivitiesDetailsActions,
  CHECK_ACTIVITIES_AVAILABILITY,
  CHECK_ACTIVITIES_AVAILABILITY_FAILURE,
  CHECK_ACTIVITIES_AVAILABILITY_SUCCESS,
  CLEAR_ACTIVITIES_AVAILABILITY,
  GET_ACTIVITIES_AVAILABLE_RANGES,
  GET_ACTIVITIES_AVAILABLE_RANGES_FAILURE,
  GET_ACTIVITIES_AVAILABLE_RANGES_SUCCESS,
  GET_ACTIVITIES_DETAILS,
  GET_ACTIVITIES_DETAILS_FAILURE,
  GET_ACTIVITIES_DETAILS_SUCCESS,
  RESTORE_ACTIVITIES_AVAILABILITY_FORM,
  RESTORE_ACTIVITIES_AVAILABILITY_SELECTED,
  SELECT_ACTIVITIES_AVAILABILITY_OPTION,
} from '../actions/travel-activities-details.actions';
export interface ActivitiesDetailState {
  details: AttractionDetailsResponse;
  loaded: boolean;
  loading: boolean;
  availabilitySearchData: AvailabilitySearchData;
  availabilityOptions: {
    options: AttractionProductOption[];
    selected: string;
    loaded: boolean;
    loading: boolean;
  };
  availableRanges: {
    ranges: ProductAvailabilityRange[];
    loaded: boolean;
    loading: boolean;
  };
}
export interface AvailabilitySearchData {
  date: Date;
  guests: { value: number; type: UppercaseGuestType }[];
  id: number;
}
export const initialState: ActivitiesDetailState = {
  details: null,
  loading: false,
  loaded: false,
  availabilitySearchData: null,
  availabilityOptions: {
    options: null,
    selected: null,
    loaded: false,
    loading: false,
  },
  availableRanges: {
    ranges: null,
    loaded: false,
    loading: false,
  },
};
export function reducer(state = initialState, action: ActivitiesDetailsActions): ActivitiesDetailState {
  switch (action.type) {
    case GET_ACTIVITIES_DETAILS:
      return {
        ...state,
        loading: true,
        loaded: false,
      };

    case GET_ACTIVITIES_DETAILS_SUCCESS: {
      const results = action.payload;
      return {
        ...state,
        details: results,
        loading: false,
        loaded: true,
      };
    }
    case GET_ACTIVITIES_DETAILS_FAILURE: {
      return initialState;
    }
    case CHECK_ACTIVITIES_AVAILABILITY: {
      return {
        ...state,
        availabilitySearchData: { ...action },
        availabilityOptions: {
          ...state.availabilityOptions,
          selected: null,
          loading: true,
          loaded: false,
        },
      };
    }
    case GET_ACTIVITIES_AVAILABLE_RANGES: {
      return {
        ...state,
        availableRanges: {
          ranges: null,
          loading: true,
          loaded: false,
        },
      };
    }
    case GET_ACTIVITIES_AVAILABLE_RANGES_SUCCESS: {
      return {
        ...state,
        availableRanges: {
          ranges: action.ranges,
          loading: false,
          loaded: true,
        },
      };
    }
    case GET_ACTIVITIES_AVAILABLE_RANGES_FAILURE: {
      return {
        ...state,
        availableRanges: initialState.availableRanges,
      };
    }
    case CHECK_ACTIVITIES_AVAILABILITY_SUCCESS: {
      return {
        ...state,
        availabilityOptions: {
          options: action.options,
          selected: null,
          loading: false,
          loaded: true,
        },
      };
    }
    case CHECK_ACTIVITIES_AVAILABILITY_FAILURE: {
      return {
        ...state,
        availabilityOptions: initialState.availabilityOptions,
      };
    }

    case CLEAR_ACTIVITIES_AVAILABILITY: {
      return {
        ...state,
        availabilitySearchData: initialState.availabilitySearchData,
        availabilityOptions: initialState.availabilityOptions,
      };
    }

    case SELECT_ACTIVITIES_AVAILABILITY_OPTION: {
      return {
        ...state,
        availabilityOptions: {
          ...state.availabilityOptions,
          selected: action.id,
        },
      };
    }

    case RESTORE_ACTIVITIES_AVAILABILITY_FORM: {
      return {
        ...state,
        availabilitySearchData: {
          id: action.id,
          date: action.date,
          guests: action.guests,
        },
      };
    }

    case RESTORE_ACTIVITIES_AVAILABILITY_SELECTED: {
      return {
        ...state,
        availabilityOptions: {
          ...state.availabilityOptions,
          selected: action.id,
        },
      };
    }

    default:
      return state;
  }
}

export const getActivitiesDetails = (state: ActivitiesDetailState) => state.details;
